import Singleton from './singleton'

export default class IconService extends Singleton {
  get resolver () {
    return (name, ext = 'svg') => {
      return require(`../../../assets/images/map/${name}.${ext}`)
    }
  }
}
